(() => {
  const markLoaded = (img) => img.classList.add('phaux-img-loaded');
  const init = () => {
    document.querySelectorAll('img[data-phaux-fade]').forEach((img) => {
      if (img.complete && img.naturalHeight > 0) {
        markLoaded(img);
      } else {
        img.addEventListener('load', () => markLoaded(img), { once: true });
        img.addEventListener('error', () => markLoaded(img), { once: true });
      }
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
